export default "__VITE_ASSET__CVbhNeuC__"